import Fuse from 'fuse.js';
import React, { useCallback } from 'react';
import { useSessionStorage } from 'react-use';
import styled from 'styled-components';
import { Observer } from '../../../CodesThatsGottaGoSomewhereElse';
import { useResolve } from '../../Container';
import { Spacer } from '../../dashboard/elements/LayoutElements';
import { EditorSession } from '../EditorSession';
import { SelectionSet } from '../Selection';
import { Colors, Input } from './../../../ui';

const SessionItem = styled.div`
    display: flex;
`;

const SessionKey = styled.div`
    width: 12rem;
    padding: .25rem;
    color: ${Colors.primaryText};
    font-weight: 450;
    text-align: right;
`;

const SessionValue = styled.div`
    padding: .25rem;
    font-family: monospace;
    white-space: pre;
    overflow: hidden;
`;

const formatSpecials = (value: any) => {
    if (value instanceof SelectionSet) {
        return {
            size: value.size,
            items: Array.from(value).map(x => [x.type, x.id]),
        };
    }
    return value;
};

export const DeveloperSessionInfo = () => {
    const session = useResolve(EditorSession);
    const [filter, setFilter] = useSessionStorage('deqo/ui/developer/session/filter', '');
    const from = useCallback((state: Record<string, any>) => {
        const keys = Object.keys(state);
        const filtered = !!filter
            ? new Fuse(keys, { includeScore: true }).search(filter).filter(x => x.score < 0.1).map(x => x.item)
            : keys;
        return filtered.sort();
    }, [filter]);
    return <>
        <Input placeholder="Filter" value={filter} onChange={setFilter} autoFocus />
        <Spacer f={2} />
        <Observer store={session} render={state =>
            <div>
                {from(state).map(k =>
                    <SessionItem key={k}>
                        <SessionKey>{k}:</SessionKey>
                        <SessionValue>{JSON.stringify(formatSpecials(state[k]), null, 4)}</SessionValue>
                    </SessionItem>
                )}
            </div>
        } />
    </>;
};
